<template>
  <div id="app">
    <Navigation></Navigation>
    <main role="main" class="container">
      <div class="row">
        <div class="col">
          <router-view/>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import Navigation from '@/components/Navigation'

export default {
  name: 'App',
  components: {
    'Navigation': Navigation
  },
  mounted: function () {
    if (this.$cookies.get('token') == null) {
      this.$http.get(process.env.VUE_APP_URL + '/token')
        .then(response => {
          this.$cookies.set('token', response.data.token)
        })
    } else {
      this.$cookies.set('token', this.$cookies.get('token'))
    }
  }
}
</script>

<style>
main {
  padding-top: 25px;
}

i.upvote, i.downvote {
  cursor: pointer;
}

body {
  background-color: #ddd;
}
</style>
